import { useState } from 'react';

import { goToApp, goToSignUp } from 'constants/routes';

import {
  CREATOR_MARKETPLACE_LISTINGS,
  PRO_FEATURES,
  PRO_MARKETPLACE_LISTINGS,
} from './constants';
import * as styled from './styles/page';
import { BookingTypes } from './ui/booking-types';
import { BrandCollabs } from './ui/brand-collabs';
import { ChooseSection } from './ui/choose-section';
import { CreatorHero } from './ui/creator-hero';
import { CriteriaGrid } from './ui/criteria-grid';
import { FeatureChecklist } from './ui/feature-checklist';
import { FinalCtaBand } from './ui/final-cta-band';
import { Footer } from './ui/footer';
import { Header } from './ui/header';
import { HeroBackdrop } from './ui/hero-backdrop';
import { HowItWorks } from './ui/how-it-works';
import { MarketplaceBand } from './ui/marketplace-band';
import { ProHero } from './ui/pro-hero';

export const LandingV2Scene = () => {
  const [view, setView] = useState<LandingV2.View>('choose');

  const showChoose = () => setView('choose');
  const showPro = () => setView('pro');
  const showCreator = () => setView('creator');

  return (
    <styled.PageWrap>
      <HeroBackdrop />
      <styled.Content>
        {view === 'choose' && (
          <ChooseSection
            onSelectPro={showPro}
            onSelectCreator={showCreator}
            onLogin={goToApp}
            onSignUp={goToSignUp}
          />
        )}

        {view !== 'choose' && (
          <Header
            view={view}
            tone="heroDark"
            onLogoClick={showChoose}
            onSelectPro={showPro}
            onSelectCreator={showCreator}
            onLogin={goToApp}
            onSignUp={goToSignUp}
          />
        )}

        {view === 'pro' && (
        <>
          <ProHero onPrimaryCta={goToSignUp} onSeeRealPage={showPro} />
          <HowItWorks />
          <FeatureChecklist
            kicker="What's on your page"
            title="Everything a client checks before they book."
            subtitle="A phone number tells them how to reach you. It doesn't tell them whether to trust you."
            features={PRO_FEATURES}
          />
          <MarketplaceBand
            tone="dark"
            kicker="The marketplace"
            title="Two ways to get found."
            description="Share your link yourself, and be listed where clients are already searching for someone who does what you do."
            ctaLabel="Browse the marketplace"
            onCtaClick={showPro}
            listings={PRO_MARKETPLACE_LISTINGS}
          />
          <FinalCtaBand
            title="Create a page. Get clients. Build your reputation."
            subtitle="Free while we're building. Claim your name before someone else does."
            ctaLabel="Create your free page"
            tone="green"
            onCtaClick={goToSignUp}
          />
        </>
      )}

      {view === 'creator' && (
        <>
          <CreatorHero onClaimLink={goToSignUp} onSeeExample={showCreator} />
          <BrandCollabs />
          <CriteriaGrid />
          <BookingTypes />
          <MarketplaceBand
            tone="light"
            kicker="The marketplace"
            title="Where brands go looking for creators."
            description="Brands, agencies and founders search Kudable by category, audience size and budget. Your page is listed from day one."
            listings={CREATOR_MARKETPLACE_LISTINGS}
          />
          <FinalCtaBand
            title="Put it in your bio. Let the page do the talking."
            subtitle="Free while we're building. Claim your name before someone else does."
            ctaLabel="Claim your link"
            tone="ink"
            onCtaClick={goToSignUp}
          />
        </>
      )}

        <Footer onSelectPro={showPro} onSelectCreator={showCreator} />
      </styled.Content>
    </styled.PageWrap>
  );
};
